import { AxiosRequestConfig } from "axios";
import { AuthenticationType } from "azure-maps-control";
import { IAzureMapOptions } from "react-azure-maps";

import { apiClient } from "@/core/api/ApiClient";
import { AzureMapsAccessTokenDto, AzureMapsSasTokenDto } from "@/core/api/generated/v1";

export class AzureMapsService {
  public async getAuthAccessToken(): Promise<AzureMapsAccessTokenDto | undefined> {
    try {
      const response = await apiClient.azureMapsApi.apiV1ProvidersAzureAzureMapsAuthAccessTokenGet({
        nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
      });
      return response.data || undefined;
    } catch (err) {
      console.error(`Error fetching Azure Maps accessToken. Error:`, err);
      return undefined;
    }
  }

  public async getAuthSasToken(): Promise<AzureMapsSasTokenDto | undefined> {
    try {
      const response = await apiClient.azureMapsApi.apiV1ProvidersAzureAzureMapsAuthSasTokenGet({
        nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
      });
      return response.data || undefined;
    } catch (err) {
      console.error(`Error fetching Azure Maps SAS token. Error:`, err);
      return undefined;
    }
  }

  public getAuthOptions(options?: {
    authSasToken?: AzureMapsSasTokenDto;
  }): IAzureMapOptions["authOptions"] {
    return {
      //https://github.com/Azure/react-azure-maps?tab=readme-ov-file#authentication

      // NB: only for development or secure environments as subscriptionKey gives full access to the Azure Maps.
      // authType: AuthenticationType.subscriptionKey,
      // subscriptionKey: azureMapsConfig.subscriptionKey,

      // auth via accessToken via Azure User-Assigned Managed Identity (UAMI)
      // authType: AuthenticationType.anonymous,
      // clientId: "514ede88-5569-46ab-b6ed-42e989b8754f",
      // getToken: (resolve, reject) => {
      //   (async () => {
      //     try {
      //       const response =
      //         await apiClient.azureMapsApi.apiV1ProvidersAzureAzureMapsAuthAccessTokenGet({
      //           nexusOpsTenant: EMPTY_TENANT_IDENTIFIER,
      //         });
      //       resolve(response.data?.accessToken || undefined);
      //     } catch (err) {
      //       reject(err);
      //     }
      //   })();
      // },

      // auth via SAS token
      authType: AuthenticationType.sas,
      getToken: (resolve, reject) => {
        (async () => {
          try {
            const sasToken = options?.authSasToken || (await this.getAuthSasToken());
            resolve(sasToken?.sasToken || undefined);
          } catch (err) {
            reject(err);
          }
        })();
      },
    };
  }

  public setAuthForRestApiRequest(params: {
    requestConfig: AxiosRequestConfig;
    accessToken?: Nil<AzureMapsAccessTokenDto>;
    sasToken?: Nil<AzureMapsSasTokenDto>;
    subscriptionKey?: string;
  }): void {
    if (params.accessToken) {
      params.requestConfig.headers ??= {};
      params.requestConfig.headers.Authorization = `Bearer ${params.accessToken.accessToken}`;
    } else if (params.sasToken) {
      params.requestConfig.headers ??= {};
      params.requestConfig.headers.Authorization = `jwt-sas ${params.sasToken.sasToken}`;
    } else if (params.subscriptionKey) {
      params.requestConfig.params ??= {};
      params.requestConfig.params["subscription-key"] = params.subscriptionKey;
    }
  }
}

export const azureMapsService = new AzureMapsService();
